import EntityWithIdStore from "./EntityWithIdStore";
import EntityWithNameStore from "./EntityWithNameStore";

class ProjectStoreClass extends EntityWithNameStore {
    constructor()
    {
        super();
        this._customerProjects = {};
    }

    getByCustomer(customerId)
    {
        const projectsByCustomer = this._customerProjects[customerId];
        return projectsByCustomer ? projectsByCustomer.getAll() : [];
    }

    _onAdd(newProject, oldProject, first)
    {
        super._onAdd(newProject, oldProject, first);

        if (oldProject && oldProject.customerId !== newProject.customerId)
            this._customerProjects[oldProject.customerId].remove(oldProject.id);

        let projectsByCustomer = this._customerProjects[newProject.customerId];
        if (!projectsByCustomer)
        {
            projectsByCustomer = new EntityWithIdStore();
            this._customerProjects[newProject.customerId] = projectsByCustomer;
        }

        if (first)
            projectsByCustomer.addFirst(newProject);
        else
            projectsByCustomer.add(newProject);
    }

    _onRemove(project)
    {
        super._onRemove(project);
        this._customerProjects[project.customerId].remove(project.id);
    }
}

const ProjectStore = new ProjectStoreClass();
export default ProjectStore;


// WEBPACK FOOTER //
// ./web/js/store/ProjectStore.js